/**
 * WorkflowCompositionPage - Workflow composition and design
 *
 * Surfaces the WorkflowCompositionManager from @ferp/workflow-forms for admin/architect users.
 * Enables visual workflow composition, fragment management, and workflow building.
 *
 * Route: /admin/workflow-composition
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconPuzzle } from '@tabler/icons-react';

import { WorkflowCompositionManager } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function WorkflowCompositionPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="teal">
            <IconPuzzle size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Workflow Composition</Title>
            <Text size="sm" c="dimmed">
              Visual workflow composition, fragment management, and workflow building
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <WorkflowCompositionManager tenant={tenant?.id ?? ''} name="Workflow Composition" />
    </Container>
  );
}

export default WorkflowCompositionPage;
